import { render, staticRenderFns } from "./BcSearchInput.vue?vue&type=template&id=c2d02c02"
import script from "./BcSearchInput.vue?vue&type=script&lang=js"
export * from "./BcSearchInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports